import "./Footer.css"
import background from './photos/background.png'
import fbIcon from './photos/fb-icon.png'
import twitterIcon from './photos/twitter-icon.png'
import {useHistory} from "react-router-dom";
import toggleMenu from "../Navbar/toggleMenu";
import News from "./News/News";


import logo from "../photos/mini-pageIcon.png";
import ucd_logo from './photos/Logo_UCDavis_leftaligned.png'
import csu_logo from './photos/Logo_CSU.jpg'
import wsu_logo from './photos/Logo_WSU.jpg'
import ad_flyer from '../Home/UpcomingWebinars/data/ad_flyer.jpg'
import Collaborators from "./Collaborators/Collaborators";



const Footer = () => {
    const hist = useHistory()

    const openMail = () => {
        window.location = 'mailto:pireslab@ucdavis.edu'
    }
    const toMedia = (e) => {
       const media = e.target.alt.trim()
       switch(media) {
           case 'fb':
               window.open('https://farmppe.netlify.app/')
               break
           case 'twitter':
               window.open('https://farmppe.netlify.app/')
               break
           default:
               window.open('https://farmppe.netlify.app/')
       }
    }
    const loadPage = (e) => {
        const target = e.target.textContent.trim().toLowerCase()
        if (target.includes("training")){
            hist.push("/training")
            toggleMenu('training')
        }else if(target.includes('team')){
            hist.push("/team")
            toggleMenu('team')
        }else if(target.includes("events")){
            hist.push("/news")
            toggleMenu('news')
        }else if (target.includes("contact")){
            hist.push('/contact')
            toggleMenu('contact')
        }else {
            hist.push("/")
            toggleMenu('home')
        }
    }

    return (
        <footer>
            <div className= 'footer-details'>
                <div className= 'background-footer' >
                    <img src = {background} alt = 'background'/>
                </div>
                {/*Summary Section*/}
                <div className = 'footer-summary'>
                    <div className= 'page-mini-logo'>
                        <img alt = 'logo' src = {logo}/>
                    </div>
                    <p> For more information, don't hesitate to email us at pireslab@ucdavis.edu</p>
                    <div className='mail-service' >
                        <input type ='email' placeholder = 'Email Address'/>
                        <span onClick={openMail}> &#10142;</span>
                    </div>

                    <div className= 'network'>
                        <div className= 'social-media-icon' >
                            <img alt = 'fb' src={fbIcon} onClick={toMedia}/>
                        </div>
                        <div className= 'social-media-icon'>
                            <img alt = 'twitter' src={twitterIcon} onClick={toMedia}/>
                        </div>
                    </div>
                </div>

                {/*Link Section*/}
                <div className= 'footer-page-links'>
                    <h2> Links </h2>
                    <p onClick={loadPage}> <span> &gt; </span> Meet the Team </p>
                    <p onClick={loadPage} > <span> &gt; </span>  Online Training </p>
                    <p onClick={loadPage} > <span> &gt; </span>  Upcoming Events </p>
                    <p onClick={loadPage}> <span> &gt; </span>  Contact Us </p>
                </div>

                {/*  News*/}
                <div className= 'footer-news'>
                    <h2> Coming Soon </h2>
                    <div className= 'footer-news-list'>
                        <p className='stay-tuned-filler'>Stay tuned for future species-specific webinars on swine and small ruminants this Fall!</p>
                        {/*<News date = "February 15, 2022"*/}
                        {/*      desc = "Mortality Management and Reporting & the Producer-Veterinarian Relationship"*/}
                        {/*      where = "(live - 5:30-6:30 PM PST/6:30-7:30 PM MT)"*/}
                        {/*      img = {news_img1}*/}
                        {/*/>*/}
                        {/* <News
                            date = "June 20th - July 28th, 2022"
                            desc = "On-farm visits to build a customized biosecurity plan for yours operation"
                              // where = "(live - 5:30-6:30 PM PST/6:30-7:30 PM MT)"
                            img = {ad_flyer}
                        /> */}
                    </div>
                </div>
                {/* Collaborators */}
                <div className= 'collaborators'>
                    <h2> Team Member Affiliations </h2>
                    <Collaborators img = {ucd_logo} url = "https://www.vetmed.ucdavis.edu/" />
                    <Collaborators img = {csu_logo} url = "https://vetmedbiosci.colostate.edu/"/>
                    <Collaborators img = {wsu_logo} url = "https://www.vetmed.wsu.edu/"/>
                </div>

            </div>

            <div className = 'credit'>
                <p>Funding for the FARM PPE project was made possible by the U.S. Department of Agriculture’s (USDA) - NADPRP through Cooperative Agreement #AP21VSSP0000C034. Its contents are solely the responsibility of the authors and do not necessarily represent the official views of the USDA</p>
                <p> Copyrights &#9400;	2022 by
                    The Regents of the University of California, Davis campus, All Rights Reserved </p>
            </div>
        </footer>
    )

}

export default Footer;